module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "single-page header-middle",
    staticStyle: {
      "position": "relative",
      "z-index": "1"
    }
  }, [_c('div', {
    staticClass: "header-top",
    style: ('padding:0px; flex: 0; background: #306FBA; transition: width .3s ease-in-out; margin-bottom: 16 px; margin-bottom: 0; color: #fff; font-size: 14px; width: 100%; z-index: 9999;box-shadow: 0 2px 9px 0 #e1e2e7; min-height: 60px;' + _vm.menuStyle)
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "max-width": "90%"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "col-lg-2"
  }, [(_vm.headLeft) ? _c('div', {
    staticClass: "logo-area"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.headLeft)
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('div', {
    staticClass: "custom-navbar"
  }), _vm._v(" "), _c('div', {
    staticClass: "main-menu main-menu-light"
  }, [(_vm.headMenuList && _vm.headMenuList.length > 0) ? _c('ul', {
    staticStyle: {
      "float": "left",
      "margin-left": "80px",
      "vertical-align": "middle",
      "margin-top": "14px"
    }
  }, [_c('li', [_c('router-link', {
    class: {
      active: _vm.$route.path === '/'
    },
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _vm._l((_vm.headMenuList), function(tab, index) {
    return _c('li', {
      key: index
    }, [_c('router-link', {
      class: {
        active: _vm.$route.name === 'menu' && _vm.$route.query.id == tab.id
      },
      attrs: {
        "to": {
          name: 'menu',
          query: {
            id: tab.id,
            title: tab.title
          }
        }
      }
    }, [_vm._v("\n                    " + _vm._s(tab.title) + "\n                  ")])], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.headRight) ? _c('ul', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('li', {
    domProps: {
      "innerHTML": _vm._s(_vm.headRight)
    }
  })]) : _vm._e()])])])])])]), _vm._v(" "), _c('router-view', {
    key: _vm.$route.fullPath,
    attrs: {
      "if": "isRouterAlive"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer color-white",
    staticStyle: {
      "background": "#306FBA"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "footer-inner"
  }, [_c('div', {
    staticClass: "footer-middle"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-6 f-col"
  }, [_c('div', {
    staticClass: "footer-static-block"
  }, [_c('div', {
    staticClass: "f-logo mb-30 mb-sm-15"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "5px"
    },
    attrs: {
      "src": require("./assets/logo2.png"),
      "alt": "鑫跃物流"
    }
  }), _c('span')])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-about mb-sm-30"
  }, [_c('p', [_vm._v("鑫跃物流是获得中国政府批准的合法经营国际快递、国内国际空运的专业化国际快递服务公司。并成为DHL中外运敦豪、TNT天地物流、美国UPS联合包裹美国FEDEX联邦快递、SAGAWA日本佐川急便等知名国际快递的一级代理商。")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-6 f-col"
  }, [_c('div', {
    staticClass: "footer-static-block"
  }, [_c('span', {
    staticClass: "opener plus"
  }), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [_vm._v("我们的服务"), _c('span')]), _vm._v(" "), _c('ul', {
    staticClass: "footer-block-contant link"
  }, [_c('li', [_vm._v("专业小程序定制，精准报价。微信咨询，即刻获取个性化方案与详细报价！")]), _vm._v(" "), _c('li', [_c('img', {
    staticStyle: {
      "border-radius": "5px",
      "width": "100px"
    },
    attrs: {
      "src": require("./assets/xcx.png"),
      "alt": "鑫跃物流"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "border-radius": "5px",
      "width": "100px"
    },
    attrs: {
      "src": require("./assets/wx.jpg"),
      "alt": "鑫跃物流"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-6 f-col"
  }, [_c('div', {
    staticClass: "footer-static-block"
  }, [_c('span', {
    staticClass: "opener plus"
  }), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [_vm._v("产品服务"), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "footer-block-contant"
  }, [_c('ul', {
    staticClass: "tagcloud"
  }, [_c('li', [_c('a', {
    staticStyle: {
      "background": "rgb(140, 197, 255)",
      "cursor": "text"
    },
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("国际快递: DHL UPS FEDEX EMS等国际快递代理服务")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "background": "rgb(140, 197, 255)",
      "cursor": "text"
    },
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("国际空运: EK EY CZ SQ MU CA PO CX 等航订舱服务")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "background": "rgb(140, 197, 255)",
      "cursor": "text"
    },
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("国际海运:APL CMA COSCO EMC HMM MSK等 海运订舱服务")])]), _vm._v(" "), _c('li', [_c('a', {
    staticStyle: {
      "background": "rgb(140, 197, 255)",
      "cursor": "text"
    },
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("国际专线:东南亚海陆空专线  欧美海陆空专线等")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-6 f-col"
  }, [_c('div', {
    staticClass: "footer-static-block"
  }, [_c('span', {
    staticClass: "opener plus"
  }), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [_vm._v("联系信息"), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "footer-block-contant"
  }, [_c('ul', {
    staticClass: "address"
  }, [_c('li', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "address-icon icon1"
  }, [_c('i', {
    staticClass: "el-icon-location-outline",
    staticStyle: {
      "font-size": "22px",
      "color": "#FFF",
      "position": "absolute"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "address"
  }, [_vm._v("仓库地址:中国广东省深圳市宝安区福永街道凤凰社区商西区 19-25 号仓库")])]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "address-icon icon1"
  }, [_c('i', {
    staticClass: "el-icon-location-outline",
    staticStyle: {
      "font-size": "22px",
      "color": "#FFF",
      "position": "absolute"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "address"
  }, [_vm._v("办公室地址:中国广东省深圳市宝安区福永街道凤凰社区合一智慧港写字楼二栋 702 室")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "address-icon icon2"
  }, [_c('i', {
    staticClass: "el-icon-phone-outline",
    staticStyle: {
      "font-size": "22px",
      "color": "#FFF",
      "position": "absolute"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("电话:18060535729 15361660396")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "address-icon icon3"
  }, [_c('i', {
    staticClass: "el-icon-eleme",
    staticStyle: {
      "font-size": "22px",
      "color": "#FFF",
      "position": "absolute"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("邮箱:yt@szxy56.com xystyt@qq.com")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-bottom text-center",
    staticStyle: {
      "border-top": "1px solid #FFF"
    }
  }, [_c('div', {
    staticClass: "copy-right-bg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row align-center"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "copy-right"
  }, [_vm._v("Copyright ©2024深圳市鑫跃顺通国际物流有限公司 | "), _c('a', {
    staticStyle: {
      "color": "#FFF"
    },
    attrs: {
      "href": "https://beian.miit.gov.cn"
    }
  }, [_vm._v("粤ICP备2024302030号")])])])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scroll-top"
  }, [_c('div', {
    staticClass: "scrollup"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c61ef43e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 721
// module chunks = 1